import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/hooks/useAuth';

import { fetchDashboardData, type IDashboardData } from '@/services/dashboard';

export function useDashboardData() {
  const { user } = useAuth();

  const { data, isLoading, error, refetch } = useQuery<IDashboardData, Error>({
    queryKey: ['dashboard'],
    queryFn: () => fetchDashboardData(),
    enabled: !!user,
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: error?.message ?? null,
    refetch,
  };
}
